











import { Vue, Component } from 'vue-property-decorator'
import { XDialog } from '@lx-frontend/cvux'

export enum ErrType {
  NETERR = 'netErr',
  OPENERR = 'openErr',
  NOTGETCAR = 'notGetCar',
}

@Component({
  components: {
    XDialog
  }
})
export default class SubmitDialog extends Vue {
  visible: boolean = false

  errType = ErrType.OPENERR

  get info() {
    const infos = {
      [ErrType.NETERR]: {
        img: require('../../stylesheets/images/off-online.png'),
        text: '网络开小差，检查网络后重试'
      },
      [ErrType.OPENERR]: {
        img: require('../../stylesheets/images/open-err.png'),
        text: '开闸失败，请联系接待人处理'
      },
      [ErrType.NOTGETCAR]: {
        img: require('../../stylesheets/images/not-get-car.png'),
        text: '出口未检测到车辆，请驶入识别区再操作开闸'
      },
    }
    return infos[this.errType]
  }

  mounted() {
    this.loadImg(require('../../stylesheets/images/off-online.png'))
  }

  loadImg(src: string) {
    // eslint-disable-next-line promise/param-names
    return new Promise((reslove, reject) => {
      const img = new Image()
      img.onload = () => {
        reslove(img)
      }
      img.onerror = () => {
        reject(src)
      }
      img.src = src
    })
  }

  show(type: ErrType) {
    this.errType = type
    this.visible = true
  }
}
